import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import IndustryPage from "@/pages/IndustryPage";
import Privacy from "@/pages/Privacy";
import { SalesPage, ManualPage } from "@/pages/DocumentsPage";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import { AppShell } from "@/components/app/AppShell";
import Portfolio from "@/pages/app/Portfolio";
import ProjectPage from "@/pages/app/ProjectPage";
import ChecksheetRunner from "@/pages/app/ChecksheetRunner";
import SettingsPage from "@/pages/app/SettingsPage";
import AuditPage from "@/pages/app/AuditPage";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/industries/:slug" element={<IndustryPage />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/sales" element={<SalesPage />} />
      <Route path="/manual" element={<Navigate to="/app/manual" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/app" element={<AppShell />}>
        <Route index element={<Portfolio />} />
        <Route path="projects/:pid" element={<ProjectPage />} />
        <Route path="projects/:pid/:tab" element={<ProjectPage />} />
        <Route path="checksheets/:cid" element={<ChecksheetRunner />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="audit" element={<AuditPage />} />
        <Route path="manual" element={<ManualPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js").catch(() => {});
  }, []);
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster theme="light" position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
